import script from "./mFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./mFooter.vue?vue&type=script&setup=true&lang=js"

import "./mFooter.vue?vue&type=style&index=0&id=6932b49a&lang=scss&scoped=true"

import exportComponent from "E:\\xm\\siggraph\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6932b49a"]])

export default __exports__